export default __webpack_public_path__ + "static/media/006.972add98.jpg";